<template>
  <a @click="goodsTap" class="goods-jump" href="javascript:">
    <slot></slot>
  </a>
</template>

<script>
import api from '../utils/api'
let flag = false
export default {
  name: 'goods-jump',
  props: {
    sku: {
      type: Object
    }
  },
  methods: {
    async goodsTap () {
      if (flag) {
        return false
      }
      flag = true
      const goodsid = this.sku.item_id
      const skuid = this.sku.sku_id
      const platform = this.sku.platform
      const type = this.sku.item_type
      await api.routeJump({ goodsid, skuid, platform, type })
      flag = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
